<template lang="html">
  <div class="orvosi">
    <v-container>

      <v-card>
        <v-card-title>
          Orvosi vizsgálatok
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Keresés"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="vizsgalatok"
          :search="search"
          @click:row="selectVizsgalat($event)"
        ></v-data-table>
      </v-card>

    </v-container>

    <v-dialog
      v-model="orvosi_dialog"
      width="700"
      persistent
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Vizsgálat rögzítése
        </v-card-title>

        <v-card-text>
          <v-form
            ref="vizsgalat_form"
            v-model="vizsgalat_valid"
          >
          <v-row>
            <v-col cols="12" md="6">
                  <v-text-field
                    v-model="date"
                    label="Vizsgálat ideje"
                    append-icon="mdi-calendar"
                    v-mask="'####-##-##'"
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="select_iroda"
                :items="irodak"
                label="Vizsgálat helye"
                outlined
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="fizetett"
                label="Fizetett"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="nem_fizetett"
                label="Nem fizetett"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            outlined
            @click="saveOrvosi()"
            :disabled="!vizsgalat_valid"
          >
            Mentés
          </v-btn>
          <v-btn
            color="red"
            outlined
            @click="orvosi_dialog = false"
          >
            Bezár
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="students_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="red"
        >
          <v-toolbar-title>Tartozó tanulók</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="students_dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <br>
          <v-row>
            <v-col cols="12" md="2" class="mt-2">
              <v-btn
                color="primary"
                outlined
                @click="ujTartozas()"
              >
                Új rögzítés
              </v-btn>
            </v-col>
            <v-col cols="12" md="10">
              <v-text-field
                v-model="student_search"
                append-icon="mdi-magnify"
                label="Tanuló keresés"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
            <v-data-table
              :headers="student_headers"
              :items="students"
              :search="student_search"
              @click:row="selectTartozas($event)"
            ></v-data-table>

        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="tartozas_dialog"
      width="700"
      persistent
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Tartozás rögzítése
        </v-card-title>

        <v-card-text>
          <v-form
            ref="tartozas_form"
            v-model="tartozas_valid"
          >
          <v-row>
            <v-col cols="12">
                  <v-text-field
                    v-model="nev"
                    label="Név"
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="12" md="6">
                  <v-text-field
                    v-model="vizsgalat_date"
                    label="Vizsgálat ideje"
                    v-mask="'####-##-##'"
                    append-icon="mdi-calendar"
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="tartozas_hely"
                :items="irodak"
                label="Vizsgálat helye"
                outlined
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="tartozast_fizetett"
                label="Fizetés dátuma"
                v-mask="'####-##-##'"
                append-icon="mdi-calendar"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="fizetes_hely"
                :items="irodak"
                label="Fizetés helye"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="description"
                outlined
                label="Megjegyzés"
              ></v-textarea>
            </v-col>
          </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="saveTartozas()"
            color="green"
            outlined
            :disabled="!tartozas_valid"
          >
            Mentés
          </v-btn>
          <v-btn
            color="red"
            outlined
            @click="tartozas_dialog = false"
          >
            Bezár
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click="ujVizsgalat()"
          fixed
          dark
          fab
          bottom
          left
          color="white"
        >
        <img src="https://www.gstatic.com/images/icons/material/colored_icons/1x/create_32dp.png">
        </v-btn>
      </template>
      <span>Új vizsgálat rogzítése</span>
    </v-tooltip>

    <v-btn
      @click="Tartozasok()"
      style="top: 80px;"
      fixed
      fab
      top
      right
      color="red"
    >
    <v-icon color="white">assignment_late</v-icon>
    </v-btn>

    <v-snackbar
      v-model="response_snackbar"
    >
      {{ response_text }}
        <v-btn
          color="pink"
          text
          @click="response_snackbar = false"
        >
          bezár
        </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

  export default {
    data () {
      return {
        vizsgalatok: [],
        search: '',
        headers: [
          { text: 'Dátum', value: 'datum' },
          { text: 'Helyszín', value: 'hely' },
          { text: 'Fizetett', value: 'fizet' },
          { text: 'Nem fizetett', value: 'nemfizet' },
        ],
        orvosi_dialog: false,
        menu: false,
        date: new Date().toISOString().slice(0,10),
        irodak: ['Helsinki', 'Szt. István', 'Festetics', 'Fiumei', 'Haller', 'Lipót', 'Fehérvári', 'Üllõi', 'Alsóerdõsor'],
        select_iroda: '',
        fizetett: '',
        nem_fizetett: '',
        selected_id: '',
        response_snackbar: false,
        response_text: '',
        students_dialog: false,
        student_search: '',
        students: [],
        student_headers: [
          { text: 'Név', value: 'nev' },
          { text: 'Vizsgálat ideje', value: 'datum' },
          { text: 'Vizsgálat helye', value: 'hely' },
          { text: 'Fizetve', value: 'fizetve' },
          { text: 'Fizetés helye', value: 'fizethely' },
          { text: 'Megjegyzés', value: 'megjegyz' },
        ],
        nev: '',
        vizsgalat_date: '',
        tartozas_hely: '',
        tartozast_fizetett: '',
        fizetes_hely: '',
        tartozas_dialog: false,
        description: '',
        tartozas_id: '',
        vizsgalat_valid: true,
        tartozas_valid: true,
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
      }
    },
    methods: {
      Vizsgalatok: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/orvosi/orvosi_list', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.vizsgalatok = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      Tartozasok: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/orvosi/tartozok_list', {
          token: this.token
        }).then((response) => {
          this.students_dialog = true
          this.preloader = false
          this.students = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      Helyszinek: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/orvosi/iroda_list', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.irodak = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveOrvosi: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/orvosi/save_orvosi', {
          token: this.token,
          date: this.date,
          select_iroda: this.select_iroda,
          fizetett: this.fizetett,
          nem_fizetett: this.nem_fizetett,
          selected_id: this.selected_id
        }).then((response) => {
          this.orvosi_dialog = false
          this.preloader = false
          this.response_snackbar = true
          this.response_text = response.data;
          this.Vizsgalatok()
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      ujVizsgalat() {
        this.orvosi_dialog = true,
        this.date = new Date().toISOString().slice(0,10),
        this.select_iroda = '',
        this.fizetett = '',
        this.nem_fizetett = '',
        this.selected_id = null
      },
      selectVizsgalat(values) {
        this.orvosi_dialog = true,
        this.date = values.datum,
        this.select_iroda = values.hely,
        this.fizetett = values.fizet,
        this.nem_fizetett = values.nemfizet,
        this.selected_id = values.id
      },
      selectTartozas(values) {
        this.tartozas_dialog = true,
        this.nev = values.nev,
        this.vizsgalat_date = values.datum,
        this.tartozas_hely = values.hely,
        this.tartozast_fizetett = values.fizetve,
        this.fizetes_hely = values.fizethely,
        this.description = values.megjegyz,
        this.tartozas_id = values.id
      },
      ujTartozas() {
        this.tartozas_dialog = true,
        this.nev = '',
        this.vizsgalat_date = '',
        this.tartozas_hely = '',
        this.tartozast_fizetett = '',
        this.fizetes_hely = '',
        this.description = '',
        this.tartozas_id = null
      },
      saveTartozas: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/orvosi/save_tartozas', {
          token: this.token,
          nev: this.nev,
          vizsgalat_date: this.vizsgalat_date,
          tartozas_hely: this.tartozas_hely,
          tartozast_fizetett: this.tartozast_fizetett,
          fizetes_hely: this.fizetes_hely,
          description: this.description,
          tartozas_id: this.tartozas_id
        }).then((response) => {
          this.tartozas_dialog = false
          this.preloader = false
          this.response_snackbar = true
          this.response_text = response.data;
          this.Tartozasok()
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      this.Vizsgalatok();
      //this.Helyszinek();
    },
    computed: {
    ...mapFields([
    'showing.preloader',
    ]),
   },
  }
</script>

<style lang="css">
</style>
